import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

const formatCurrency = (value) => `Rp. ${new Intl.NumberFormat('id-ID').format(value || 0)}`;

const BalanceIncomeCard = ({ saldoData }) => {
    const cards = [
        {
            title: 'Total Saldo Aktif',
            value: formatCurrency(saldoData?.active_saldo),
            trend: 'up',
        },
        {
            title: 'Total Saldo Ditarik',
            value: formatCurrency(saldoData?.penarikan),
            trend: 'down',
        },
        {
            title: 'Total Pendapatan',
            value: formatCurrency(saldoData?.pendapatan),
            trend: 'neutral',
        },
    ];

    const renderTrendIcon = (trend) => {
        if (trend === 'up') return <Typography sx={{ color: 'green', fontWeight: 'bold' }}>⬆️</Typography>;
        if (trend === 'down') return <Typography sx={{ color: 'red', fontWeight: 'bold' }}>⬇️</Typography>;
        return <Typography sx={{ color: 'gray', fontWeight: 'bold' }}>—</Typography>;
    };

    const renderCard = (card, index) => (
        <Box
            key={index}
            sx={{
                flex: '0 0 auto',
                minWidth: '300px',
                maxWidth: '300px',
                margin: '0 8px',
            }}
        >
            <Card
                sx={{
                    boxShadow: 3,
                    borderRadius: 3,
                    p: 2,
                    background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)',
                }}
            >
                <CardContent>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 2,
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                            {card.title}
                        </Typography>
                        {renderTrendIcon(card.trend)}
                    </Box>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0d47a1' }}>
                        {card.value}
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );

    return (
        <>
            {/* Mobile View */}
            <Box
                sx={{
                    display: { xs: 'flex', sm: 'none' },
                    overflowX: 'auto',
                    padding: '16px',
                    whiteSpace: 'nowrap',
                }}
            >
                {cards.map((card, index) => renderCard(card, index))}
            </Box>

            {/* Desktop View */}
            <Grid
                container
                spacing={2}
                sx={{
                    display: { xs: 'none', sm: 'flex' },
                    justifyContent: 'space-between',
                }}
            >
                {cards.map((card, index) => (
                    <Grid
                        key={index}
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        {renderCard(card, index)}
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default BalanceIncomeCard;
